<template>
    <rkm-layout-body title="Lista de paciente">
        <rkm-layout-content>
            <List ref="List" />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/historico-atendimento/List'

export default {
    components: { List },
}
</script>